const initialState = {
  customerLogoImage: null,
  fetchedCustomerLogo: false,
};

const customerLogoReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CUSTOMER_LOGO':
      return {
        ...state,
        fetchedCustomerLogo: true,
        customerLogoImage: action.payload,
      };
    default:
      return state;
  }
};

export default customerLogoReducer;
